import { HTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/cn";

interface Props extends HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "subtle";
  padding?: "none" | "default" | "sm";
}

export const Card = forwardRef<HTMLDivElement, Props>(function Card(
  { variant = "default", padding = "default", className, ...rest }, ref
) {
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-lg border border-border",
        variant === "default" ? "bg-bg-elevated" : "bg-bg-subtle",
        padding === "default" && "p-4",
        padding === "sm" && "p-2",
        className,
      )}
      {...rest}
    />
  );
});
